import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FileCheck, Upload, BellRing, Printer } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { DOC_TYPES, DOC_STATUS, fmtDate, fmtDateTime } from "@/lib/util";
import { Loader, Pill, FileButton, Field, VehNo, docColor } from "@/components/common";
import DocUploadModal from "@/components/DocUploadModal";
import Modal from "@/components/Modal";
import { PageTitle, Table, Td, DriverPicker } from "@/pages/admin/ui";

export default function Documents() {
  const [sp] = useSearchParams();
  const [f, setF] = useState({ status: sp.get("status") || "", doc_type: "" });
  const [list, setList] = useState(null);
  const [pick, setPick] = useState(false);
  const [sel, setSel] = useState([]);
  const [up, setUp] = useState(null);
  const load = () => api.get("/documents", { params: f }).then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, [f]); // eslint-disable-line react-hooks/exhaustive-deps
  const alerts = async () => {
    try { const { data } = await api.post("/documents/run-alerts"); toast.success(`تم إرسال ${data.sent} تنبيه`); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageTitle title="المستندات" sub="التنبيه قبل الانتهاء حسب الفترة المحددة في الإعدادات" icon={FileCheck} color="text-green-700">
        <Link data-testid="monthly-report-link" to="/admin/documents/monthly" className="btn btn-md btn-ghost"><Printer className="w-5 h-5" />تقرير الشهر للطباعة</Link>
        <button data-testid="run-doc-alerts-btn" onClick={alerts} className="btn btn-md btn-ghost"><BellRing className="w-5 h-5" />إرسال تنبيهات الانتهاء</button>
        <button data-testid="docs-upload-btn" onClick={() => { setSel([]); setPick(true); }} className="btn btn-md btn-green"><Upload className="w-5 h-5" />رفع مستند لسائق</button>
      </PageTitle>
      <div className="flex flex-wrap gap-3 mb-4">
        <select data-testid="docs-status-filter" className="field field-sm w-48" value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })}>
          <option value="">كل الحالات</option><option value="alert">قريب الانتهاء أو منتهي</option>{Object.entries(DOC_STATUS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        <select data-testid="docs-type-filter" className="field field-sm w-56" value={f.doc_type} onChange={(e) => setF({ ...f, doc_type: e.target.value })}>
          <option value="">كل الأنواع</option>{Object.entries(DOC_TYPES).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
      </div>
      {!list ? <Loader /> : (
        <Table head={["المستند", "صاحب المستند", "الرقم", "الإصدار", "الانتهاء", "الحالة", "آخر تحديث", ""]} testid="documents-table">
          {list.map((d) => <tr key={d.id}>
            <Td className="font-bold">{d.name}</Td>
            <Td>{d.driver ? <Link to={`/admin/drivers/${d.driver_id}`} className="text-blue-700">{d.driver.full_name} <span className="ltr">{d.driver.serial}</span></Link> : <span>مركبة <VehNo adm={d.vehicle_admin_number} plate={d.vehicle_plate} /></span>}</Td>
            <Td>{d.number || "—"}</Td><Td>{fmtDate(d.issue_date)}</Td><Td>{fmtDate(d.expiry_date)}</Td>
            <Td><Pill color={docColor(d.status)}>{DOC_STATUS[d.status]}{d.days_left != null && d.status !== "valid" ? ` (${d.days_left} يوم)` : ""}</Pill></Td>
            <Td className="whitespace-nowrap">{fmtDateTime(d.updated_at)}</Td>
            <Td className="flex gap-1"><FileButton fileId={d.file_id} label="عرض" className="btn btn-sm btn-ghost" testid={`docs-open-${d.id}`} />
              <button onClick={() => setUp({ doc: d, driverId: d.driver_id, vehicleId: d.vehicle_id })} className="btn btn-sm btn-ghost">تحديث</button></Td>
          </tr>)}
        </Table>
      )}
      <Modal open={pick} onClose={() => setPick(false)} title="اختر السائق" testid="docs-pick-driver">
        <Field label="السائق"><DriverPicker selected={sel} onChange={setSel} testid="docs-driver-picker" /></Field>
        <button data-testid="docs-pick-continue" disabled={!sel.length} onClick={() => { setPick(false); setUp({ driverId: sel[0].id }); }} className="btn btn-lg btn-green w-full">متابعة</button>
      </Modal>
      <DocUploadModal open={!!up} onClose={() => setUp(null)} driverId={up?.driverId} vehicleId={up?.vehicleId} doc={up?.doc} onSaved={load} />
    </div>
  );
}
